// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3vwyX","containerItemsCenter":"Skeleton_containerItemsCenter__1KVro"};